import Component from '../core/Component';
import $ from 'jquery';
//import { throttle } from 'lodash';
import * as ViewportServices from '../services/Viewport';
//import keycodes from 'keycodes';
//import { queries } from '../core/config';
//import enquire from 'enquire.js';

export default class Menu extends Component {

    constructor($element) {
        super($element);
        this.$body = $('body');
        this.$document = $(document);
        this.$window = $(window);
        this.$nav = $('.nav');

        this.class = 'show-menu';
    }

    prepare() {
        this.$element.on('click', ::this.toggleCategories);
        this.$document.on('load:beforeLeave', () => {
            this.$body.removeClass(this.class);
        });
    }

    STATE = false;
    SCROLLED = false;

    destroy() {
        this.$document.off('click', ::this.closeCategories);
    }

    toggleCategories(event) {
        event.stopPropagation();
        if (this.STATE) {
            this.$body.removeClass(this.class);
            this.STATE = false;
        } else {
            this.$body.addClass(this.class);
            this.STATE = true;
        }
    }

    closeCategories(event) {
        if (this.STATE) {
            this.$body.removeClass(this.class);
            this.STATE = false;
        }
    }
}


// WEBPACK FOOTER //
// ./components/Menu.js